/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Column,
  Row,
  Text,
  TEXT_VARIANTS,
  Icon,
  IconNames,
  Input,
} from "../components";
import { COLORS } from "../shared/theme";

const SETTINGS = {
  PROFILE: "PROFILE",
  ACCOUNT: "ACCOUNT",
  MEMBERSHIP: "MEMBERSHIP",
  BILLING: "BILLING",
  NOTIFICATIONS: "NOTIFICATIONS",
};

const SaveButton = styled.button`
  background-color: #e2fea4;
  border-radius: 10px;
  border-width: 0px;
  padding-top: 5px;
  padding-bottom: 5px;
  transition-duration: 120m;
  transition-property: all;
  padding-left: 10px;
  paddig-right: 10px;
  height: 45px;
  font-size: 20px;
  text-align: center;
  letter-spacing: -0.02em;
  font-weight: 590;
  transition-duration: 120m;
  transition-property: all;

  &:hover {
    cursor: pointer;
    background: #949ca6;
    color: #ffffff;
  }
`;

const Header = styled.h2`
  color: #949ca6;
  letter-spacing: -0.02em;
  font-size: 20px;
  height: 35px;
  line-height: 35px;
  font-weight: 590px;
`;

const MainHeader = styled.h1`
  color: #000000;
  width: 114px;
  height: 30px;
  font-size: 30px;
  letter-spacing: -0.01em;
  font-weight: 700;
`;

const SidebarButton: React.FC<
  React.ComponentProps<typeof Button> & { active?: boolean }
> = ({ active, ...props }) => (
  <Button
    align="start"
    textVariant={TEXT_VARIANTS.T20}
    textColor={COLORS.BLACK}
    css={css`
      background-color: ${active ? COLORS.LIME : "transparent"};

      &:hover {
        background-color: ${active ? COLORS.LIME : COLORS.LIGHT};
      }
    `}
    {...props}
  />
);

const Settings: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(SETTINGS.PROFILE);
  const navigate = useNavigate();

  return (
    <Column
      gap={60}
      css={css`
        width: 1266px;
        max-width: calc(100% - 20px);
        padding-bottom: 50px;
      `}
    >
      <Row gap={5} crossAxisAlignment="center">
        <Button
          leadingElement={() => <Icon name={IconNames.Back} />}
          onClick={() => navigate(-1)}
        />
        <Text variant={TEXT_VARIANTS.T30}>{"Settings"}</Text>
      </Row>
      <Row gap={100}>
        <Column
          as="aside"
          gap={35}
          style={{
            width: 400,
          }}
        >
          <Column gap={5}>
            <SidebarButton
              onClick={() => setCurrentPage(SETTINGS.PROFILE)}
              active={currentPage === SETTINGS.PROFILE}
              label="Profile"
            />
            <SidebarButton
              onClick={() => setCurrentPage(SETTINGS.ACCOUNT)}
              active={currentPage === SETTINGS.ACCOUNT}
              label="Account"
            />
            <SidebarButton
              onClick={() => setCurrentPage(SETTINGS.MEMBERSHIP)}
              active={currentPage === SETTINGS.MEMBERSHIP}
              label="Membership"
            />
            <SidebarButton
              onClick={() => setCurrentPage(SETTINGS.BILLING)}
              active={currentPage === SETTINGS.BILLING}
              label="Billing"
            />
            <SidebarButton
              onClick={() => setCurrentPage(SETTINGS.NOTIFICATIONS)}
              active={currentPage === SETTINGS.NOTIFICATIONS}
              label="Notifications"
            />
          </Column>
          <SidebarButton textColor={COLORS.SILVER} label="Log out" />
        </Column>
        <Column>
          <Column gap={30}>
            <Column>
              <MainHeader>{'Profile'}</MainHeader>
            </Column>
            <Column gap={30}>
              <Column gap={5}>
                <Header>{'Full name'}</Header>
                <Input type="text" withResetButton />
              </Column>
              <Column gap={5}>
                <Header>{'Username'}</Header>
                <Input type="text" withResetButton />
              </Column>
              <Column gap={5}>
                <Header>Bio</Header>
                <textarea
                  css={{
                    width: 766,
                    height: 110,
                    borderColor: "#e2e6eb",
                    borderStyle: "solid",
                    padding: 10,
                    fontSize: 20,
                    fontWeight: 400,
                    letterSpacing: "-0.02em",
                    borderRadius: 10,
                    borderWidth: 2,
                  }}
                ></textarea>
              </Column>
              <Column gap={5}>
                <Header>{'Website'}</Header>
                <Column gap={5}>
                  <Input type="text" withResetButton />
                </Column>
              </Column>
              <SaveButton>{'Save'}</SaveButton>
            </Column>
          </Column>
        </Column>
      </Row>
    </Column>
  );
};

export default Settings;
